import { batteryPricingBundle } from "./battery-pricing-bundle"
import { PricingIncentivesStep } from "../../ProposalSetup/pricing/PricingIncentivesStep"

export { LOAN_PAYEE_M2_NOTICE } from "./battery-pricing-bundle"
export { INCENTIVES_PRICING_REQUIRED } from "../../ProposalSetup/pricing/PricingIncentivesStep"

export const IncentivesStep = ({
  proposalId,
  onClose,
}: {
  proposalId: string
  onClose: () => void
}): JSX.Element => (
  <PricingIncentivesStep
    kind={batteryPricingBundle}
    proposalId={proposalId}
    onClose={onClose}
  />
)
